module.exports = __webpack_public_path__ + "static/media/CngIcon.a235f77b.svg";